
import Vue from "vue";
export default Vue.extend({
	props: {
		label: String
	},
	methods: {
		click(){
			this.$emit("click");
		}
	}
});
